module.exports = __webpack_public_path__ + "static/img/191.f52f672.png";